module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAUCAYAAACEYr13AAAAa0lEQVQ4EaXBsQ3AMAzAMOn/o12NhScDIeWRPJJHskw4MESWCQeGyDLhwBBZJhwYIkcTfgyRowk/hsgy4cAQWSYcGCLLhANDZJlwYIgcTfgxRI4m/Bgiy4QDQ2SZcGCILBMODJFlwoEh8ugDepJAFe/+nM0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/number_score_03.png
// module id = 236
// module chunks = 0